import { jsx as _jsx } from "react/jsx-runtime";
import { SearchDistrictTypes } from '../config/types';
import AgentsSearchDistrictPrimary from './components/primary';
import AgentsSearchDistrictSecondary from './components/secondary';
const AgentsSearchDistrict = ({ type = SearchDistrictTypes.Primary }) => type === SearchDistrictTypes.Primary ? _jsx(AgentsSearchDistrictPrimary, {}) : _jsx(AgentsSearchDistrictSecondary, {});
export default AgentsSearchDistrict;
